<template>
	<div class=" ">
		<el-card>
			<div slot="header" class="card_title">
				<span>新增推送信息</span>
			</div>
			<div class="add_main hidden_scroll">
				<div class="margin_top_20">
					<el-form
						label-position="right"
						label-width="120px"
						:model="formData"
						:rules="rule"
						ref="formData"
					>
						<el-form-item label="类型" prop="type">
							<el-radio-group v-model="formData.type">
								<el-radio
									v-for="(item, index) in typeList"
									:key="index"
									:label="item.id"
									>{{ item.name }}</el-radio
								>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="标题" prop="title" class="margin_top_20">
							<el-input
								v-model="formData.title"
								placeholder="标题，需小于50字"
								maxlength="50"
							></el-input>
						</el-form-item>
						<el-form-item label="说明" prop="desc">
							<el-input
								v-model="formData.desc"
								placeholder="说明，需小于200字"
								maxlength="200"
							></el-input>
						</el-form-item>

						<el-form-item label="内容ID" prop="object_id">
							<el-input
								v-model="formData.object_id"
								placeholder="只能是数字"
								type="number"
							></el-input>
						</el-form-item>
						<el-form-item>
							<div class="flex justify_content_c align_items_c">
								<el-button
									type="primary"
									class="custom_btn_width_100"
									@click="submit('formData')"
									>保存</el-button
								>
								<el-button
									class="custom_btn_width_100"
									@click="$router.push({ path: '/limitsauthority/personnel' })"
									>返回</el-button
								>
							</div>
						</el-form-item>
					</el-form>
				</div>
			</div>
		</el-card>
	</div>
</template>

<script>
import { addAliPush } from "@/api/user";
import {
	validateEqNotNull,
	validateNull,
	validatePhone,
} from "@/utils/validate";
export default {
	name: "",
	data() {
		return {
			value: "",
			formData: {
				title: "",
				object_id: 0,
				type: 1,
				desc: "",
			},
			typeList: [
				{
					id: 1,
					name: "文章",
				},
				{
					id: 2,
					name: "快讯",
				},
				{
					id: 55,
					name: "专栏",
				},
				{
					id: 7,
					name: "活动",
				},
			],
			rule: {
				title: [{ validator: validateNull, trigger: "blur", required: true }],
				desc: [{ validator: validateNull, trigger: "blur", required: true }],
				object_id: [
					{ validator: validateNull, trigger: "blur", required: true },
				],
			},
		};
	},
	created() {},
	methods: {
		// 新增资讯提交
		submit(formName) {
			const that = this;
			const objectId = that.formData.object_id;

			if (!that.formData.title || that.formData.title.length < 1) {
				that.$message.error("请选择推送标题");
				return;
			}
			if (!that.formData.desc || that.formData.desc.length < 1) {
				that.$message.error("请选择推送内容");
				return;
			}
			that.formData.object_id = Number(that.formData.object_id);
			addAliPush(that.formData)
				.then((res) => {
					if (res.code == 200) {
						that.$router.push({ path: "/information/push" });
					} else {
						this.$message.error(res.message);
					}
				})
				.catch((error) => {
					this.$message.error(error.message);
				});
		},
	},
};
</script>

<style scoped>
.main {
	width: calc(100% - 40px);
}

.add_main {
	width: 70%;
	height: 81vh;
	overflow-y: scroll;
	margin: 0 auto;
}
</style>
